import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/lib/AuthContext";

/** Redirects to /change-password until `must_change_password` is cleared.
 *
 * The change-password page itself is excluded from the redirect; otherwise we'd
 * loop. Login is also excluded so the bootstrap-admin first-login flow works:
 * log in with the seeded credentials → forced to change → log in again with
 * the new password.
 */
export function MustChangePasswordGuard({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const location = useLocation();
  const exempt =
    location.pathname.startsWith("/change-password") ||
    location.pathname.startsWith("/login");

  if (user?.must_change_password && !exempt) {
    return <Navigate to="/change-password" replace />;
  }
  return <>{children}</>;
}
